"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EditProfile;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _awsAmplify = require("aws-amplify");
var _CreateProfileComponent = _interopRequireDefault(require("../components/CreateProfileComponent"));
var _images = _interopRequireDefault(require("../common_features/assets/images"));
var _reactRedux = require("react-redux");
var _roleReducer = require("../common_features/redux/reducers/roleReducer");
var _Services = require("../common_features/utility/Services");
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _userDetailsReducer = require("../common_features/redux/reducers/userDetailsReducer");
var _strings = require("../common_features/utility/strings");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function EditProfile(props) {
  const navigate = (0, _reactRouterDom.useNavigate)();
  const dispatch = (0, _reactRedux.useDispatch)();
  const {
    userInfo
  } = (0, _reactRedux.useSelector)(state => state.login);
  const userType = userInfo.userType === 4 || userInfo.userType === 6;
  const userData = (0, _reactRedux.useSelector)(state => {
    var _state$userDetails;
    return state === null || state === void 0 ? void 0 : (_state$userDetails = state.userDetails) === null || _state$userDetails === void 0 ? void 0 : _state$userDetails.data;
  });
  const [isLoading, setIsLoading] = (0, _react.useState)(true);
  const [country, setCountry] = (0, _react.useState)({});
  const [countryList, setCountryList] = (0, _react.useState)([]);
  const [countries, setCountries] = (0, _react.useState)('');
  const [zipcode, setZipcode] = (0, _react.useState)('');
  const [isZipCodeValid, setIsZipCodeValid] = (0, _react.useState)(false);
  const [firstName, setfirstName] = (0, _react.useState)(null);
  const [lastName, setlastName] = (0, _react.useState)(null);
  const [phoneNumber, setPhoneNumber] = (0, _react.useState)(null);
  const [email, setEmail] = (0, _react.useState)(null);
  const [organization, setOrganization] = (0, _react.useState)(null);
  const [userNewData, setUserNewData] = (0, _react.useState)({});
  const [currentCountry, setCurrentCountry] = (0, _react.useState)({});
  const [isPhoneNumberError, setIsPhoneNumberError] = (0, _react.useState)(false);
  const [a, setA] = (0, _react.useState)("");
  const [isPhoneNumberBlurError, setIsPhoneNumberBlurError] = (0, _react.useState)();
  const [smsInviteModal, setSmsInviteModal] = (0, _react.useState)(false);
  const [emailChange, setEmailChange] = (0, _react.useState)(false);
  const [smsChecked, setSmsChecked] = (0, _react.useState)(false);
  const [checkboxChecked, setCheckboxChecked] = (0, _react.useState)(false);
  const [openErrorModal, setOpenErrorModal] = (0, _react.useState)(false);
  const [showModal, setShowModal] = (0, _react.useState)(false);
  const successData = {
    variant: "password-change-modal",
    displayCrossIcon: false,
    modalHeaderText: "Profile Updated",
    modalHeaderTextStyle: {
      fontSize: 16,
      paddingBottom: 16,
      color: "#4F8309"
    },
    modalDetailText: "Your profile has been updated successfully.",
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px"
    },
    positiveActionButtonTitle: "Continue",
    negativeButtonActionTitle: null,
    positiveAction: () => {
      setShowModal(false);
    }
  };
  const handlePhoneNumberBlur = value => {
    setIsPhoneNumberError(value);
  };
  const getCountryData = async () => {
    setIsLoading(true);
    (0, _Services.getCountryList)().then(res => {
      if (res.success) {
        const countries = res.data ? res.data.map(country => {
          return {
            code: country.code,
            title: country.name,
            key: country.name + country.code,
            callingCode: "+".concat(country.callingCode)
          };
        }) : [];
        setCountryList(countries);
      }
    });
    setIsLoading(false);
  };
  const onZipcodeBlur = e => {
    setIsLoading(true);
    (0, _Services.GetCityState)({
      zipcode: e.target.value,
      country: currentCountry.code
    }).then(data => {
      if (data.error) {
        setIsLoading(false);
        setIsZipCodeValid(true);
      } else {
        setIsLoading(false);
        setIsZipCodeValid(false);
      }
    });
  };
  const onChangeHandler = async function (e, name) {
    var _e$target$value;
    setZipcode(((_e$target$value = e.target.value) === null || _e$target$value === void 0 ? void 0 : _e$target$value.length) <= 5 ? e.target.value : zipcode);
    if (!e.target.onblur) {
      e.target.onblur = onZipcodeBlur;
    }
  };
  const onChangeFirstNameHandler = async function (e) {
    setfirstName(e.target.value);
  };
  const onChangeLastNameHandler = async function (e) {
    setlastName(e.target.value);
  };
  const onChangeCountryHandler = async function (e) {
    setCountries(e.title);
    setCountry(e);
  };
  const getRolesData = async () => {
    var _roles$data;
    const roles = await (0, _Services.getRoles)();
    let roleId = roles === null || roles === void 0 ? void 0 : (_roles$data = roles.data) === null || _roles$data === void 0 ? void 0 : _roles$data[0].roleId;
    dispatch((0, _roleReducer.roleInfo)(roles.data));
    return roleId;
  };
  const getUsersData = async () => {
    setIsLoading(true);
    try {
      var _userDetailsData$data, _userDetailsData$data2, _userDetailsData$data3, _userDetailsData$data4, _userDetailsData$data5, _userDetailsData$data6, _userDetailsData$data7, _userDetailsData$data8, _userDetailsData$data9, _userDetailsData$data10, _userDetailsData$data11, _userDetailsData$data12, _userDetailsData$data13, _userDetailsData$data14, _userDetailsData$data15, _userDetailsData$data16, _userDetailsData$data17, _userDetailsData$data18, _userDetailsData$data19;
      let roleID = await getRolesData();
      let user = await _awsAmplify.Auth.currentAuthenticatedUser();
      let userPoolId = user.pool.userPoolId;
      let authUsername = user.username;
      let USERID = "".concat(userPoolId, "#").concat(authUsername);
      let newUserId = USERID;
      const userDetailsData = await (0, _Services.getUsers)(roleID, newUserId);
      let fName = userDetailsData === null || userDetailsData === void 0 ? void 0 : (_userDetailsData$data = userDetailsData.data) === null || _userDetailsData$data === void 0 ? void 0 : _userDetailsData$data.firstName;
      setfirstName(fName);
      let lName = userDetailsData === null || userDetailsData === void 0 ? void 0 : (_userDetailsData$data2 = userDetailsData.data) === null || _userDetailsData$data2 === void 0 ? void 0 : _userDetailsData$data2.lastName;
      setlastName(lName);
      let email = userDetailsData === null || userDetailsData === void 0 ? void 0 : (_userDetailsData$data3 = userDetailsData.data) === null || _userDetailsData$data3 === void 0 ? void 0 : _userDetailsData$data3.email;
      setEmail(email);
      let number = userDetailsData === null || userDetailsData === void 0 ? void 0 : (_userDetailsData$data4 = userDetailsData.data) === null || _userDetailsData$data4 === void 0 ? void 0 : _userDetailsData$data4.phoneNumber;
      setPhoneNumber(number);
      let organization = userType ? userDetailsData === null || userDetailsData === void 0 ? void 0 : userDetailsData.data.Organization.name : userDetailsData === null || userDetailsData === void 0 ? void 0 : (_userDetailsData$data5 = userDetailsData.data) === null || _userDetailsData$data5 === void 0 ? void 0 : (_userDetailsData$data6 = _userDetailsData$data5.ServiceProvider) === null || _userDetailsData$data6 === void 0 ? void 0 : _userDetailsData$data6.name;
      setOrganization(organization);
      let address = await JSON.parse(userDetailsData === null || userDetailsData === void 0 ? void 0 : (_userDetailsData$data7 = userDetailsData.data) === null || _userDetailsData$data7 === void 0 ? void 0 : _userDetailsData$data7.address);
      let nameCountry = address === null || address === void 0 ? void 0 : address.country;
      setCountries(nameCountry);
      const currentCountry = [...countryList].filter(cnt => cnt.title === nameCountry)[0];
      const contryPrifix = [...countryList].filter(cnt => cnt.title === nameCountry)[0];
      setA(contryPrifix === null || contryPrifix === void 0 ? void 0 : contryPrifix.callingCode);
      setCurrentCountry(currentCountry);
      let countryZipcode = address === null || address === void 0 ? void 0 : address.zipcode;
      setZipcode(countryZipcode);
      let checkEmail = (_userDetailsData$data8 = userDetailsData === null || userDetailsData === void 0 ? void 0 : (_userDetailsData$data9 = userDetailsData.data) === null || _userDetailsData$data9 === void 0 ? void 0 : (_userDetailsData$data10 = _userDetailsData$data9.UserNotifyPref) === null || _userDetailsData$data10 === void 0 ? void 0 : (_userDetailsData$data11 = _userDetailsData$data10.pref) === null || _userDetailsData$data11 === void 0 ? void 0 : _userDetailsData$data11.email) !== null && _userDetailsData$data8 !== void 0 ? _userDetailsData$data8 : false;
      setEmailChange(checkEmail);
      let smsCheck = (_userDetailsData$data12 = userDetailsData === null || userDetailsData === void 0 ? void 0 : (_userDetailsData$data13 = userDetailsData.data) === null || _userDetailsData$data13 === void 0 ? void 0 : (_userDetailsData$data14 = _userDetailsData$data13.UserNotifyPref) === null || _userDetailsData$data14 === void 0 ? void 0 : (_userDetailsData$data15 = _userDetailsData$data14.pref) === null || _userDetailsData$data15 === void 0 ? void 0 : _userDetailsData$data15.sms) !== null && _userDetailsData$data12 !== void 0 ? _userDetailsData$data12 : false;
      setSmsChecked(smsCheck);
      let HelpFulCheck = (_userDetailsData$data16 = userDetailsData === null || userDetailsData === void 0 ? void 0 : (_userDetailsData$data17 = userDetailsData.data) === null || _userDetailsData$data17 === void 0 ? void 0 : (_userDetailsData$data18 = _userDetailsData$data17.UserNotifyPref) === null || _userDetailsData$data18 === void 0 ? void 0 : (_userDetailsData$data19 = _userDetailsData$data18.pref) === null || _userDetailsData$data19 === void 0 ? void 0 : _userDetailsData$data19.helpfulTips) !== null && _userDetailsData$data16 !== void 0 ? _userDetailsData$data16 : false;
      setCheckboxChecked(HelpFulCheck);
      dispatch((0, _userDetailsReducer.userDetailsInfo)(userDetailsData.data));
      setUserNewData(userDetailsData.data);
    } catch (error) {
      setIsLoading(false);
    }
  };
  const handleOptinButton = () => {
    if ((userData === null || userData === void 0 ? void 0 : userData.phoneNumber) !== phoneNumber && phoneNumber.length === 1) {
      setOpenErrorModal(true);
    } else if ((userData === null || userData === void 0 ? void 0 : userData.phoneNumber) === phoneNumber || phoneNumber === null) {
      updateUserProfile();
    } else if ((userData === null || userData === void 0 ? void 0 : userData.phoneNumber) !== phoneNumber && phoneNumber.length === 11) {
      setSmsInviteModal(true);
    }
  };
  const updateNumberCalled = () => {
    let optPayload = {
      "langPref": "en_US",
      "pref": {
        "email": emailChange,
        "sms": smsChecked,
        "helpfulTips": checkboxChecked
      },
      "isOptIn": true
    };
    setSmsInviteModal(false);
    updateUserProfile(optPayload);
  };
  const handleCancelModal = () => {
    setSmsInviteModal(false);
    updateUserProfile();
  };
  const updateUserProfile = async (optPayload, isDeletePhone) => {
    let countryName = countryList === null || countryList === void 0 ? void 0 : countryList[0].title;
    let countryZipcode = zipcode;
    let address = {
      "country": countryName,
      "zipcode": countryZipcode
    };
    setIsLoading(true);
    await (0, _Services.updateProfile)(firstName, lastName, JSON.stringify(address), phoneNumber, optPayload, isDeletePhone).then(apiResp => {
      if (apiResp && apiResp.success) {
        dispatch((0, _userDetailsReducer.userDetailsInfo)({
          ...userNewData,
          phoneNumber,
          firstName,
          lastName,
          address: JSON.stringify(address),
          optPayload,
          isDeletePhone
        }));
        setShowModal(true);
      }
      setIsLoading(false);
    }).catch(error => {
      alert(error);
      setIsLoading(false);
    });
  };
  (0, _react.useEffect)(() => {
    getCountryData();
  }, []);
  (0, _react.useEffect)(() => {
    getUsersData().then(() => setIsLoading(false));
  }, [countryList]);
  (0, _react.useEffect)(() => {
    var _ref;
    console.log("phoneNumberLength:-", phoneNumber, phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.length);
    let phoneNumberLength = (_ref = phoneNumber !== null && phoneNumber !== void 0 && phoneNumber.includes("+") ? phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.substr(a === null || a === void 0 ? void 0 : a.length) : phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.substr((a === null || a === void 0 ? void 0 : a.length) - 1)) === null || _ref === void 0 ? void 0 : _ref.length;
    if (phoneNumberLength === 0) {
      setIsPhoneNumberBlurError(false);
    } else {
      setIsPhoneNumberBlurError(isPhoneNumberError && phoneNumberLength !== 10);
    }
  }, [phoneNumber, isPhoneNumberError]);
  const navigateForceChangePassword = () => {
    navigate(_RoutePath.default.ChangeCurrentPassword.useLink);
  };
  const navigateNotificationScreen = () => {
    navigate(_RoutePath.default.NotificationPreferences.useLink);
  };
  const onClickCancel = () => {
    navigate(_RoutePath.default.admin.useLink);
  };
  const onContinueNumberDelete = () => {
    setOpenErrorModal(false);
    let isDeletePhone = {
      "langPref": "en_US",
      "pref": {
        "email": emailChange,
        "sms": smsChecked,
        "helpfulTips": checkboxChecked
      },
      isDeletePhone: true
    };
    updateUserProfile(isDeletePhone);
  };
  const onCancelNumberDelete = () => {
    setOpenErrorModal(false);
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_CreateProfileComponent.default, {
    variant: "warning-modal",
    displayModal: openErrorModal,
    modalHeaderIcon: true,
    displayCrossIcon: false,
    modalDetailText: "Removing your mobile number will disable SMS messages",
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px"
    },
    positiveActionButtonTitle: "Continue",
    negativeButtonActionTitle: "Cancel",
    positiveAction: onContinueNumberDelete,
    negativeAvtion: onCancelNumberDelete,
    modalHeaderTextNP: "Text Message Opt-In Confirmation",
    modalDetailTextNP: _strings.termsString.MAIN_CONTENT,
    reInviteModalNP: smsInviteModal,
    positiveActionButtonTitleNP: "I Confirm",
    negativeButtonActionTitleNP: "Cancel",
    handleResendInviteModalNP: updateNumberCalled,
    handleSetReInviteCancelModalNP: handleCancelModal,
    onEditProfile: true,
    isLoading: isLoading,
    rightArrow: _images.default.ArrowRight.default,
    headerText: "Edit Profile",
    phoneNumberText: "Mobile Phone Number",
    notificationsText: "This will be used for SMS notifications",
    zipCodeText: "Zip Code",
    countryText: "Country",
    firstNameText: "First Name",
    firstName: firstName,
    onChangeFirstName: e => onChangeFirstNameHandler(e),
    lastNameText: "Last Name",
    lastName: lastName,
    onChangeLastName: e => onChangeLastNameHandler(e),
    phoneNumber: phoneNumber,
    onChangePhoneNumber: (e, value) => {
      setPhoneNumber(e);
    },
    emailText: "Email",
    email: email,
    onChangeEmail: email => {
      setEmail(email);
    },
    emailPlaceholder: "Enter Email",
    organizationText: "Organization",
    organization: organization,
    onChangeOrganization: organization => {
      setOrganization(organization);
    },
    organizationPlaceholder: "Enter Organization",
    countryDropDownList: countryList,
    countries: countries,
    setCountry: e => {
      onChangeCountryHandler(e);
    },
    zipCode: zipcode,
    setZipCode: e => {
      setZipcode(e.target.value);
      onChangeHandler(e, 'zipcode');
    },
    isZipCodeValid: isZipCodeValid,
    saveButton: "Save",
    editProfile: true,
    onCLickChangePassword: navigateForceChangePassword,
    onCLickNotificationPreferences: navigateNotificationScreen,
    onClickSave: handleOptinButton,
    onClickSaveDisabled: !((firstName === null || firstName === void 0 ? void 0 : firstName.length) > 0 && (lastName === null || lastName === void 0 ? void 0 : lastName.length) > 0 && countries && !isZipCodeValid && !isPhoneNumberBlurError && (zipcode === null || zipcode === void 0 ? void 0 : zipcode.length) === 5),
    isCancel: true,
    cancelButton: "Cancel",
    onClickCancel: onClickCancel,
    handlePhoneNumberBlur: handlePhoneNumberBlur,
    isPhoneNumberError: isPhoneNumberError,
    isPhoneNumberBlur: isPhoneNumberBlurError,
    country: country.code,
    editModalData: successData,
    showModal: showModal,
    isValidPhoneNumber: (phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.length) > 10 || (phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.length) === undefined ? true : false,
    numberInvalidText: (phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.length) > 10 || (phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.length) === undefined ? "This will be used for SMS notifications" : "Please enter a valid phone number"
  }));
}